module.exports = __webpack_public_path__ + "img/maintenance4.9a385d8e.jpg";